import ZlbConfirm from '@/components/ZlbConfirm';
import { zlbApiExpenseOrgRelationManageQueryInstitutionDeletedGet } from '@/api/zlbExpense';

const responseErrorHandle = (res) => {
  const { success, message, statusText } = res;
  if (!success) {
    ZlbConfirm({
      title: message || statusText,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

const formatTree = (tree) => {
  if (tree.length) {
    tree?.forEach((item) => {
      item.label = item.name;
      item.value = item.code;
      if (item.children) formatTree(item.children);
    });
  }
};

export default {
  namespace: 'invoiceData',
  state: {
    tree: [],
    orgList: [],
  },
  effects: {
    * getInstitution ({ payload }, { call, put }) {
      const result = yield call(zlbApiExpenseOrgRelationManageQueryInstitutionDeletedGet, payload);
      yield put({
        type: 'update',
        payload: {
          orgList: result,
        },
      });
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
